<template>
  <div>
    <p class="text-base font-medium text-center mt-5 fade-in">Redirecting...</p>
  </div>
</template>

<script>
export default {
  name: 'AdvertisementRedirect',
  data: () => ({
    isBootstrapped: false,
	inventoryCount: 0
  }),
  components: {
  },
  beforeRouteEnter(to, from, next) {
    const id = to.params.id;

    // Check if ID is not a valid positive integer
    if (!/^\d+$/.test(id)) {
      window.location.href = "https://www.thebrokersite.com";
    } else {
      next(); 
    }
  },
  async created() {
    try {
      const id = this.$route.params.id
      const res = await this.$http.get(`/api/advertisements/${id}`)

      if(res.status === 200 && res.data.redirectURL) {
        window.location.href = res.data.redirectURL;
      } else {
        window.location.href = "https://www.thebrokersite.com";
      }

    } catch (err) {
      console.log("err", err)
    }

  }

}
</script>


<style scoped>
  .fade-in {
    animation: fadeIn 1s ease-in-out infinite alternate;
  }

  @keyframes fadeIn {
    from { opacity: 0.4; }
    to   { opacity: 1; }
  } 
</style>